import React, {Fragment} from "react";
import RootlineTable from "./RootlineTable";
import {Route} from "react-router-dom";

const RootlineRoute = () => {
    return (
        <Route path="/billing/rootline" component={RootlinePage}/>
    );
};

const RootlinePage = () => {
    return (
        <Fragment>
            <h1 className="mb-5">Rootline PayIt Events</h1>
            <RootlineTable/>
        </Fragment>
    )
}

export default RootlineRoute;
